import { z } from "zod";

export const DischargeLetterFormSchema = z.object({
  test1: z.string().optional(),
  test2: z.string().optional(),
  test3: z.string().optional(),
  test4: z.string().optional(),
  test5: z.string().optional(),
});
